const topics = [
  { name: '热血冒险', count: '12,580', icon: 'ri-fire-line', color: 'primary' },
  { name: '恋爱甜宠', count: '9,320', icon: 'ri-heart-line', color: 'secondary' },
  { name: '奇幻异世界', count: '8,750', icon: 'ri-magic-line', color: 'accent' },
  { name: '悬疑推理', count: '6,210', icon: 'ri-search-eye-line', color: 'primary' },
  { name: '搞笑日常', count: '7,890', icon: 'ri-emotion-laugh-line', color: 'accent' },
  { name: '校园青春', count: '5,670', icon: 'ri-school-line', color: 'secondary' },
  { name: '科幻未来', count: '4,980', icon: 'ri-rocket-line', color: 'primary' },
  { name: '古风武侠', count: '6,450', icon: 'ri-sword-line', color: 'accent' },
  { name: '都市职场', count: '4,320', icon: 'ri-building-line', color: 'secondary' },
  { name: '恐怖灵异', count: '3,890', icon: 'ri-ghost-line', color: 'primary' },
  { name: '竞技体育', count: '3,560', icon: 'ri-basketball-line', color: 'accent' },
];

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: { bg: 'bg-primary-100', text: 'text-primary-700', iconBg: 'bg-primary-200' },
  secondary: { bg: 'bg-secondary-100', text: 'text-secondary-700', iconBg: 'bg-secondary-200' },
  accent: { bg: 'bg-accent-100', text: 'text-accent-700', iconBg: 'bg-accent-200' },
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          探索当下最受欢迎的漫画题材分类
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => {
            const c = colorMap[topic.color];
            return (
              <div
                key={topic.name}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-full ${c.bg} cursor-pointer transition-transform hover:scale-105`}
              >
                <div className={`w-7 h-7 rounded-full ${c.iconBg} flex items-center justify-center`}>
                  <i className={`${topic.icon} ${c.text} text-xs`}></i>
                </div>
                <span className={`text-sm font-medium ${c.text} whitespace-nowrap`}>{topic.name}</span>
                <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.count}部</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}